import { differenceInMonths, parseISO } from 'date-fns';

export const getGroupingStrategy = (
  mapFilters: Record<string, string> | null,
  coverQuarters = true
) => {
  if (mapFilters?.history_after) {
    const startDate = parseISO(mapFilters.history_after);
    //If no history_before is provided, use the current date
    const endDate = parseISO(
      mapFilters.history_before || new Date().toISOString()
    );
    const monthDiff = differenceInMonths(endDate, startDate);

    if (monthDiff < 48) return 'MONTHS';
    // If the month difference is greater than 48, and coverQuarters is true, return QUARTERS
    if (coverQuarters) return 'QUARTERS';
  }
  return 'MONTHS'; // default grouping strategy
};

export const determineNullsOrder = (
  ordering?: string
): { nullsLast: boolean | undefined; nullsFirst: boolean | undefined } => {
  if (!ordering) return { nullsLast: undefined, nullsFirst: undefined };
  const nullsLast = ordering === '-finalized_at';
  const nullsFirst = ordering === 'finalized_at';

  return { nullsLast, nullsFirst };
};

export const computeGeometryAreaIdOrStageId = (
  geometry?: string | null,
  areaId?: string | null,
  stageId?: string | string[] | null
) => {
  if (stageId) {
    const normalizedStageId = Array.isArray(stageId) ? stageId : [stageId];
    if (normalizedStageId.length === 0) return undefined;
    return { project_stage_id: normalizedStageId };
  }
  if (areaId) return { area_id: areaId };
  if (geometry) return { geometry };

  return undefined;
};
